﻿import { $, get } from "@/Utils"

const startLoading = () => $(".maps-closest__button .loading-anim").style.visibility = "visible";
const startLoadingById = () => get(buttonIdValue).style.visibility = "visible";
export const stopLoading = () => $(".maps-closest__button .loading-anim").style.visibility = "hidden";
export const minZoom = 8;
export const maxZoom = 17;
let buttonIdValue = "";

const positionError = () => {
    const toggleAlert = () => $(".map-alert").classList.toggle("alert--active");
    toggleAlert();
    window.setTimeout(toggleAlert, 5000);
    stopLoading();
}

const positionOptions = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0
} as PositionOptions;

export const bindFindClosestButton = (positionSuccess: PositionCallback, buttonId: string = "") => {
    buttonIdValue = buttonId;

    const mapsClosestButton = buttonIdValue !== "" ? get(buttonId) : $(".maps-closest__button");
    if (!mapsClosestButton) return;

    if (!("geolocation" in navigator)) {
        mapsClosestButton.style.display = "none";
        return;
    }

    if (buttonIdValue === "") {
        mapsClosestButton.addEventListener("click", () => {
            startLoading();
            navigator.geolocation.getCurrentPosition(positionSuccess, positionError, positionOptions);
        });
    } else {
        mapsClosestButton.addEventListener("click", () => {
            startLoadingById();
            navigator.geolocation.getCurrentPosition(positionSuccess, positionError, positionOptions);
        });
    }
}
